export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="font-heading text-xl font-bold text-background-50 whitespace-nowrap cursor-pointer">YY漫画</a>
            <p className="mt-3 text-xs leading-relaxed text-background-50/50">
              YY漫画是专业的漫画阅读平台，提供海量韩漫、日漫免费全集。支持追更提醒、智能收藏、下拉式阅读，为漫迷打造极致追漫体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速入口</h4>
            <div className="flex flex-col gap-2">
              <a href="#features" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">追漫体验</a>
              <a href="#cards" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门推荐</a>
              <a href="#ranking" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">人气榜单</a>
              <a href="#updates" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">更新快讯</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#cards" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">韩漫大全</a>
              <a href="#cards" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">日漫全集</a>
              <a href="#cards" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热血战斗</a>
              <a href="#cards" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">恋爱甜漫</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-50/40 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 YY漫画. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">用户协议</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}